import { render, staticRenderFns } from "./LoginDirectForm.vue?vue&type=template&id=b0e99206&scoped=true"
import script from "./LoginDirectForm.vue?vue&type=script&lang=js"
export * from "./LoginDirectForm.vue?vue&type=script&lang=js"
import style0 from "./LoginDirectForm.vue?vue&type=style&index=0&id=b0e99206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e99206",
  null
  
)

export default component.exports